/**
 * Skeleton for a program card (programs list and program detail course cards).
 * Greyed-out placeholder with shimmer for loading states.
 */
export function ProgramCardSkeleton() {
  return (
    <div className="rounded-2xl bg-card border border-border overflow-hidden h-full flex flex-col animate-pulse">
      <div className="p-6 flex-1 flex flex-col">
        <div className="h-6 w-24 rounded-full bg-muted mb-4" />
        <div className="h-5 w-3/4 bg-muted rounded mb-2" />
        <div className="h-4 w-full bg-muted rounded mb-1" />
        <div className="h-4 w-5/6 bg-muted rounded mb-5" />
        <div className="h-3 w-16 bg-muted rounded mb-5" />
        <div className="flex justify-between items-center pt-4 border-t border-border mt-auto">
          <div className="h-5 w-20 bg-muted rounded" />
          <div className="h-4 w-14 bg-muted rounded" />
        </div>
      </div>
    </div>
  );
}

export function ProgramCardSkeletonGrid({ count = 6 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {Array.from({ length: count }, (_, i) => (
        <ProgramCardSkeleton key={i} />
      ))}
    </div>
  );
}
